exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#_1Duwphv0px3KMYU1SOOYNt{z-index:4}#_1Duwphv0px3KMYU1SOOYNt td{position:relative;width:34%;height:34%}#_27xeATAQLvT4FmQdXbGUDg{z-index:2}#_27xeATAQLvT4FmQdXbGUDg td{position:relative;width:100%;height:34%}#_6MQ3iXvf5RyJBs7bhesSQ{z-index:3}#_6MQ3iXvf5RyJBs7bhesSQ td{position:relative;width:34%;height:100%}._3wOEOiAfgqRXU5hLfb0Sx2{position:fixed;table-layout:fixed;top:0;left:0;border-spacing:0;border-collapse:collapse;width:100%;height:100%}._-ZaP7hGSjUaK3XjNtxunE{position:absolute;top:0;left:0;border:none;width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"rootFine": "_1Duwphv0px3KMYU1SOOYNt",
	"rootCourseRow": "_27xeATAQLvT4FmQdXbGUDg",
	"rootCourseColumn": "_6MQ3iXvf5RyJBs7bhesSQ",
	"rootGrid": "_3wOEOiAfgqRXU5hLfb0Sx2",
	"rootGridWidget": "_-ZaP7hGSjUaK3XjNtxunE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Overlay/index.css
// module id = 480
// module chunks = 1